import { Link } from "react-router-dom";
import arrowIcon from "./../../../assets/svg/discoverArrow.svg";

const DiscoverButton = ({ url }) => {
  const Wrapper = url === undefined ? "div" : Link;

  return (
    <Wrapper className="dButton" {...(url && { to: url })}>
      <p className="discover">Discover</p>
      <img className="discoverArrow" src={arrowIcon} alt="Discover" />
    </Wrapper>
  );
};

export default DiscoverButton;
